import { SSO_MODES } from "constants/ssoModes";

export function isAgisMembershipMode(values) {
  return values.includes(SSO_MODES.AGIS);
}
